import { z } from 'zod'

/**
 * FO-033 — Gedeeld request-schema voor de ops-rapportage-instellingen.
 *
 * Eén bron: de API gebruikt dit (`.parse`/`.safeParse`) én het backoffice-form
 * valideert er client-side mee, zodat het form niets kan sturen dat de API weigert.
 */
export const OpsReportSettingsSchema = z.object({
  recipients: z
    .array(z.string().trim().email('Ongeldig e-mailadres').max(200))
    .min(1, 'Minimaal één ontvanger'),
  weeklyEnabled: z.boolean(),
  monthlyEnabled: z.boolean(),
  // null = geen override; de code valt terug op de default (claude-sonnet-4-6).
  llmModel: z.string().trim().min(1).max(100).nullable(),
  analysisEnabled: z.boolean(),
})

export type OpsReportSettingsInput = z.infer<typeof OpsReportSettingsSchema>
